import logo from './logo.svg';
import './App.css';
import HealthcareChatbot from './components/HealthcareChatbot';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1 id ="head">Healthcare Assistant App</h1>
        <p>
          Welcome to your personal healthcare information assistant.
        </p>
        <div className="feature-list">
          <div className="feature-item">
            <span className="feature-icon">🩺</span>
            <span>Get general health information</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">💊</span>
            <span>Learn about common symptoms</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🏃‍♂️</span>
            <span>Receive wellness and fitness tips</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🧠</span>
            <span>Get stress management advice</span>
          </div>
        </div>
        <p className="cta-text">
          Click the healthcare assistant button at the top to start chatting!
        </p>
        <div className="disclaimer">
          <p>
            <strong>⚠️ Important:</strong> This chatbot provides general health information only.
            For medical emergencies, call 911. Always consult healthcare professionals for 
            medical diagnosis, treatment, or specific health concerns.
          </p>
        </div>
      </header>
      <HealthcareChatbot />
    </div>
  );
}

export default App;
